module.exports = __webpack_public_path__ + "static/media/w3-t.2fa43af4.jpg";